<template>
    <div>
        <input type="hidden" name="_token" :value="csrfToken">
        <input type="hidden" name="institute_id" :value="instituteId">
        <input type="hidden" name="course_id" :value="courseId">
        <input 
            v-if="residencesObj && residencesObj.length > 0" 
            type="hidden" 
            name="residence_id"
            :value="residenceId != 0 ? residenceId : ''"
        >
        <input 
            v-if="airportsObj && airportsObj.length > 0" 
            type="hidden" 
            name="airport_id"
            :value="airportId != 0 ? airportId : ''"
        >
        <input type="hidden" name="insurance_price" :value="dataObj.insurance">
        <input type="hidden" name="insurance_price_value" :value="dataObj.insurance_price">
        <input 
            v-if="dataObj.visa != 0" 
            type="hidden" 
            name="visa_checker" 
            :value="visaChecker"
        >
        <input type="hidden" name="insurance_checker" :value="insuranceChecker">
        <input type="hidden" name="coupon_code" :value="couponCode">
        <input class="invoice_checker" type="hidden" name="" value="0">
        <input class="WASendOffer" type="hidden" name="" value="0">
        <input class="save_new_student_offer" type="hidden" name="" value="0">
        <input 
            v-if="isAdmin == '1' && requestId" 
            type="hidden" 
            name="request_id" 
            value=""
        >
        <input 
            v-if="compareOffer" 
            type="hidden" 
            name="compare_offer" 
            value="1"
        >
        <input type="hidden" name="currency_code" :value="dataObj.currency?.code || 'SAR'">
    </div>
</template>

<script>
export default {
    name: 'HiddenFields',
    props: {
        csrfToken: String,
        instituteId: [String, Number],
        courseId: [String, Number],
        residencesObj: [Array, Object],
        airportsObj: [Array, Object],
        residenceId: [String, Number],
        airportId: [String, Number],
        dataObj: Object,
        visaChecker: [String, Number],
        insuranceChecker: [String, Number],
        couponCode: String,
        isAdmin: [String, Number],
        requestId: [String, Number],
        compareOffer: Boolean,
    },
};
</script>